import { Font } from "@/src/components/base";
import style from "./style.module.scss";
import Icons from "@/src/components/base/Icons";
export default function Header({
  withBack = false,
  onClick,
  logo,
  text = "",
  id = "",
}: {
  children?: string;
  withBack?: boolean;
  onClick?: () => void;
  logo?: boolean;
  text?: string;
  id?: string;
}): JSX.Element {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };
  return (
    <div
      className={`${style["container-header"]} ${
        withBack
          ? style["container-header--withback"]
          : style["container-header--withoutback"]
      } `}
    >
      {withBack && (
        <div style={{ padding: 12 }} onClick={handleClick} id={id}>
          <Icons
            select={"arrow_back"}
            size={"18"}
            color={"white"}
            rotate={"180"}
          />
        </div>
      )}

      <div
        style={withBack ? { paddingRight: "24px" } : {}}
        className={`${style.header} ${
          logo || (text.length && withBack === false)
            ? style["header--center"]
            : style["header--start"]
        }`}
      >
        {logo && (
          <div
            className={style.logo_wrapper}
          >
            <img
              src="https://bribrain-assets.bbri.io/images/main/mobile/bribrain-logo.webp"
              alt="bribrain-logo"
            />
          </div>
        )}
        {text.length !== 0 && (
          <Font variant={"subtitle-1-semibold"} color={"white"}>
            {text}
          </Font>
        )}
      </div>
    </div>
  );
}
